import { HotelPricingConfig } from '@monorepo/functions/src/types/config'
import { format } from 'date-fns'

import { usePricingPeriodEditorOptional } from '@/shared/providers/PricingPeriodEditorProvider'
import { usePricingPeriods, useResolvedPricingConfig } from '@/shared/providers/PricingPeriodProvider'

export type UseHotelPricingConfigOptions = {
    referenceDate?: Date | string
    periodId?: string
}

const emptyConfig = null as unknown as HotelPricingConfig

export const useHotelPricingConfig = (options?: UseHotelPricingConfigOptions) => {
    const editorContext = usePricingPeriodEditorOptional()
    const { updatePeriod, periods, loading, currentPeriod } = usePricingPeriods()

    const effectivePeriodId = options?.periodId ?? editorContext?.periodId
    const { config } = useResolvedPricingConfig(options?.referenceDate, effectivePeriodId)

    const updateConfig = (newConfig: Partial<HotelPricingConfig>) => {
        const targetPeriodId = effectivePeriodId ?? currentPeriod?.id
        if (!targetPeriodId) return
        updatePeriod(targetPeriodId, newConfig)
    }

    return {
        config: config ?? emptyConfig,
        updateConfig,
        loading,
        periods,
        currentPeriod,
    }
}
